export const CALL_INTEL_BASE_URL = '/analytics/call-intelligence';
export const CALL_RECORDING_SETTINGS = '/phone/call-recording';

export const BACKFILL_WETAG = 'call-intel-backfill';
export const BACKFILL_RELEVANCE_WINDOW_DAYS = 7;
